import { BrandConfig } from '../types';

export const gorampeBrand: BrandConfig = {
  key: 'gorampe',
  name: 'Soumission rampe',
  shortName: 'Soumission rampe',
  tagline: 'Pour Tous · For All',
  colors: {
    primary: '#22D3EE',
    primaryHover: '#06B6D4',
    navy: '#0A1128',
    navyDark: '#060918',
    blueAccent: '#2D7FF9',
  },
  fonts: {
    displayName: 'Inter Tight',
    bodyName: 'Inter',
    googleFontsUrl:
      'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Inter+Tight:wght@500;600;700;800&family=JetBrains+Mono:wght@400;500;700&display=swap',
  },
  contact: {
    email: '',
    website: '',
  },
  pdfHeaderSubtitle: 'Soumission rampe · Pour Tous · For All',
  pwaManifest: {
    name: 'Soumission rampe',
    short_name: 'Soumission',
    theme_color: '#0A1128',
    background_color: '#F5F7FA',
    icon_192: '/icon-192.png',
    icon_512: '/icon-512.png',
  },
};
